// extracted by mini-css-extract-plugin
module.exports = {"readingsWrapper":"MeterReadings_readingsWrapper_31zhA"};